import React, { useContext, useState } from "react";
import classes from "./Header.module.css";
import { Link, useNavigate } from "react-router-dom";
import { auth } from "../../Utility/firebase";

import { HiOutlineLocationMarker } from "react-icons/hi";
import { HiOutlineSearch } from "react-icons/hi";
import { PiShoppingCartSimpleBold } from "react-icons/pi";

import flag from "../../image/flag.png";
import logo from "../../image/logo.png";
import LowerHeader from "./LowerHeader";
import { GiHamburgerMenu } from "react-icons/gi";
import { DataContext } from "../DataProvider/DataProvider";

function Header() {
  const [{ basket, user }, dispatch] = useContext(DataContext);
  const [selectedCategory, setSelectedCategory] = useState("");
  const navigate = useNavigate();
  const totalItem = basket?.reduce((amount, item) => item.amount + amount, 0);

  const handleCategoryChange = (e) => {
    const category = e.target.value;
    setSelectedCategory(category);
    if (category && category !== "") {
      navigate(`/category/${encodeURIComponent(category)}`);
    }
  };
  return (
    <>
      <section className={classes.sticky}>
        <div className={classes.header_container}>
          {" "}
          <div className={classes.logo_container}>
            <div className={classes.hamburger}>
              <GiHamburgerMenu size={25} />
            </div>
            <Link to="/">
              <div>
                <img className={classes.logo} src={logo} alt="logo" />
              </div>
            </Link>

            <div className={classes.location}>
              <span>
                <HiOutlineLocationMarker />
              </span>
              <div>
                <p>Deliver to </p>

                <span>Ethiopia</span>
              </div>
            </div>
          </div>
          <div className={classes.search}>
            <select
              name="Category"
              id="category_dropdown"
              value={selectedCategory}
              onChange={handleCategoryChange}
            >
              <option value="">All</option>
              <option value="electronics">Electronics</option>
              <option value="jewelery">Jewelery</option>
              <option value="men's clothing">Men's Clothing</option>
              <option value="women's clothing">Women's Clothing</option>
            </select>
            <input type="text" placeholder="Search Amazon" />
            <HiOutlineSearch size={38} />
          </div>
          <div className={classes.order_container}>
            <Link to="" className={classes.language}>
              <img src={flag} alt="flag" />
              <select name="" id="">
                <option value="">EN</option>
              </select>
            </Link>

            <Link to={!user && "/auth"}>
              <div>
                {user ? (
                  <>
                    <p>hello,{user?.email?.split("@")[0]}</p>
                    <span onClick={() => auth.signOut()}>Sign Out</span>
                  </>
                ) : (
                  <>
                    <p>Hello, sign In</p>
                    <span>Account & lists</span>
                  </>
                )}
              </div>
            </Link>
            <Link to="/orders">
              <p>Returns</p>
              <span>& Orders</span>
            </Link>
            <Link to="/cart" className={classes.cart}>
              <PiShoppingCartSimpleBold size={35} />
              <span>{totalItem}</span>
            </Link>
          </div>
        </div>
        <LowerHeader />
      </section>
    </>
  );
}

export default Header;
